<template>
  <div>
    <div class="header">
      <span class="md-title">{{ modalInfo.title }}</span>
      <span class="close-icon" @click="$emit('close')"> X </span>
    </div>

    <div :class="'content ' + modalInfo.name" v-if="modalInfo.name === 'addCategory'">
      <input type="text" v-model="categoryName" :placeholder="$i18nUtil.trans('UB015')" />
    </div>

    <div :class="'content ' + modalInfo.name" v-if="modalInfo.name === 'editCategory'">
      <input type="text" />
    </div>

    <div :class="'content ' + modalInfo.name" v-if="modalInfo.name === 'newFolder'">
      <input type="text" v-model="folderName" :placeholder="$i18nUtil.trans('message.placeholder.newFolder','새폴더')" />
    </div>

    <div :class="'content ' + modalInfo.name" v-if="modalInfo.name === 'fileUpload'">
      <input multiple type="file" id="file-upload" ref="uploadfile" @change="changeFile" />
    </div>

    <div :class="'footer ' + modalInfo.name" v-if="modalInfo.name === 'addCategory'">
      <button class="btn_submit" @click="$emit('close')">{{ $i18nUtil.trans("button.register","등록") }}</button>
      <button class="btn_cancel" @click="$emit('close')">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
    </div>

    <div :class="'footer ' + modalInfo.name" v-if="modalInfo.name === 'editCategory'">
      <button class="btn_submit" @click="$emit('close')">{{ $i18nUtil.trans("button.save","저장") }}</button>
      <button class="btn_cancel" @click="$emit('close')">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
    </div>

    <div :class="'footer ' + modalInfo.name" v-if="modalInfo.name === 'newFolder'">
      <button class="btn_submit" @click="onClickSubmit">{{ $i18nUtil.trans("button.confirm","확인") }}</button>
      <button class="btn_cancel" @click="$emit('close')">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
    </div>

    <div :class="'footer ' + modalInfo.name" v-if="modalInfo.name === 'fileUpload'">
      <button class="btn_submit" @click="onClickSubmit">{{ $i18nUtil.trans("button.save","저장") }}</button>
      <button class="btn_cancel" @click="$emit('close')">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    name: {
      type: String,
      required: false,
    },
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      folderName: "",
      categoryName: "",
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "top-left",
          duration: 2000,
        },
      },
    };
  },
  methods: {
    /* 토스트 알림 호출 */
    //...mapActions("modal", ["showToast"]),

    onClickSubmit() {
      /* 새 폴더 만들기 확인 */
      if (this.modalInfo.name === "newFolder") {
        const data = {};
        if (this.folderName === "") {
          this.folderName = this.$i18nUtil.trans("message.placeholder.newFolder","새폴더");
        }
        data.folderName = this.folderName;

        /* if (this.data.dropedFile !== undefined) {
          data.dropedFile = this.data.dropedFile;
        } */
        /* if (this.data.targetFile !== undefined) {
          data.targetFile = this.data.targetFile;
        } */
        this.$emit("addFolder", data);
        this.$emit("toastInfo", this.toastInfo);
        //this.toastInfo.message = "새 폴더가 추가되었습니다.";
      }

      if (this.modalInfo.name === "fileUpload") {
        this.$emit("fileUpload", this.modalInfo);
      }

      if (this.modalInfo.name === "addCategory") {
      }

      if (this.modalInfo.name === "editCategory") {
      }
      this.$emit("close");
    },
    changeFile() {
      let files = this.$refs.uploadfile.files;
      if (files.length) {
        this.$emit("setUploadData", files);
        /* this.uploadFile({
          uploadList: files
        }); */
      }
    },
  },
};
</script>

<style scoped>
.header {
  padding: 1em;
  color: #fff;
  background-color: #404040;
}
.header .md-title {
  font-size: 16px;
  padding-left: 15px;
}
.header .close-icon {
  float: right;
  cursor: pointer;
}
.header .close-icon .md-icon {
  color: #fff;
}

.content {
  width: 90%;
  margin: 15px auto;
}
.content input {
  width: 100%;
  height: 40px;
}

.footer {
  width: 90%;
  margin: 15px auto;
  margin-top: 30px;
  text-align: center;
}
.footer.newFolder {
  text-align: right;
}

.btn_submit {
  border: none;
  color: #fff;
  font-size: 16px;
  padding: 5px 20px;
  border-radius: 3px;
  background-color: #ff6600;
}
.btn_cancel {
  border: none;
  color: #fff;
  font-size: 16px;
  padding: 5px 20px;
  border-radius: 3px;
  background-color: #7f7f7f;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/FileModal.vue